import { IMAGES } from "../../lib/data";
import { Reveal, Overline } from "./Reveal";

export const About = () => (
  <section id="about" data-testid="about-section" className="py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <Reveal className="order-2 lg:order-1">
        <Overline>About</Overline>
        <h2 className="mt-5 font-heading text-4xl md:text-5xl font-light tracking-tight text-charcoal leading-tight">
          A calm, hands-on approach rooted in care for the horse
        </h2>
        <div className="mt-7 space-y-5 text-stone text-lg font-light leading-relaxed">
          <p>
            Stride &amp; Stone Equine was founded on a simple belief: every horse deserves to move comfortably and feel their best, whether they're competing at the top of their discipline or enjoying quiet hacks at home.
          </p>
          <p>
            As a qualified equine sports massage therapist, I provide a thorough, tailored full-body treatment, reading each horse's body and working at a pace they're happy with. No two horses are the same, so no two sessions are either.
          </p>
          <p>
            Treatments take place at your own barn in familiar surroundings, keeping your horse relaxed while we work to release tension, improve movement, and support long-term soundness.
          </p>
        </div>
        <div className="mt-10 flex gap-10">
          <div>
            <p className="font-heading text-4xl text-clay">Full body</p>
            <p className="text-sm text-stone mt-1">Complete treatment, every session</p>
          </div>
          <div>
            <p className="font-heading text-4xl text-clay">At your barn</p>
            <p className="text-sm text-stone mt-1">Familiar, stress-free surroundings</p>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.15} className="order-1 lg:order-2">
        <div className="relative">
          <img
            src={IMAGES.horseNeck}
            alt="Portrait of a horse"
            className="w-full aspect-[3/4] object-cover rounded-[2rem] shadow-lg"
          />
          <div className="absolute inset-0 rounded-[2rem] ring-1 ring-inset ring-charcoal/5" />
        </div>
      </Reveal>
    </div>
  </section>
);
